import TestingSourceControl from "pages/Testing/view/components/TestingSourceControl";
import { CompetencyMapOptionList, ScenarioOption } from "pages/Testing/view/types";

interface ICompetencyMapInfoProps {
  competencyMaps: CompetencyMapOptionList;
  scenarios: ScenarioOption[] | undefined;
  isEditing: boolean;
  competencyMapsLoading: boolean;
  scenariosLoading: boolean;
}

const CompetencyMapInfo = ({
  competencyMaps,
  scenarios,
  isEditing,
  competencyMapsLoading,
  scenariosLoading,
}: ICompetencyMapInfoProps) => (
  <TestingSourceControl
    competencyMaps={competencyMaps}
    scenarios={scenarios}
    isEditing={isEditing}
    competencyMapsLoading={competencyMapsLoading}
    scenariosLoading={scenariosLoading}
    type='trial'
  />
);

export default CompetencyMapInfo;
